import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div id="api-explorer">
      <h2>{`API Explorer`}</h2>
      <p>{`The `}<a href="https://developers.giphy.com/explorer/">{`API Explorer`}</a>{` is a nifty tool that lets you take the API for a spin by inputting some sample queries and viewing the live responses!`}</p>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      